<template>
    <div class="groupStrength">
        <div class="header-bg">
            <img src="../../assets/images/group/banner.png" alt="">
        </div>
        <div ref="navigator" :class="scroll >= navHeight ? 'marBot' : ''">
            <nav class="nav" :class="scroll >= navHeight ? 'active' : ''">
                <el-tabs v-model="activeName" @tab-click="handleClick">
                    <el-tab-pane label="集团实力" name="/groupStrength/group"></el-tab-pane>
                    <el-tab-pane label="关于我们" name="/groupStrength/about"></el-tab-pane>
                    <el-tab-pane label="新闻资讯" name="/groupStrength/news"></el-tab-pane>
                </el-tabs>
            </nav>
        </div>
        <router-view></router-view>
    </div>
</template>
<script>
    export default {
        data() {
            var self = this
            return {
                activeName: self.$route.path,
                scroll: 0,
                navHeight: 0
            }
        },
        mounted() {
            this.$nextTick(() => {
                this.navHeight = this.$refs.navigator.offsetTop
                window.addEventListener("scroll", this.handleScroll);
            })
        },
        destroyed() {
            window.removeEventListener("scroll", this.handleScroll);
        },
        methods: {
            handleClick(val){
                if(this.$route.path == val.name) return
                this.$router.push(val.name)
            },
            handleScroll() {
                this.scroll = document.documentElement.scrollTop || document.body.scrollTop;
                console.log('scroll:'+this.scroll);
                console.log('navHeight:'+this.navHeight);
            },
        }
    }
</script>
<style lang="scss" scoped>
    .groupStrength {
        .header-bg {
            width: 100%;
            height: 550px;
            img {
                width: 100%;
                height: 550px;
            }
        }
        .nav {
            width: 100%;
            height: 91px;
            background: #fff;
            padding-left: 360px;
            box-sizing: border-box;
            border-bottom: 1px solid #EEEEEE;
            position: relative;
            z-index: 999;
        }
        .active {
            position: fixed;
            left: 0;
            top: 0;
            right: 0;
            z-index: 999;
        }
        .marBot {
            padding-bottom: 91px;
        }
    }
    @media screen and (max-width: 800px) {
        .groupStrength {
            .header-bg {
                width: 100%;
                height: 550px;
                img {
                    width: 100%;
                    height: 550px;
                }
            }
            .nav {
                width: 100%;
                height: 180px;
                background: #fff;
                padding-left: 360px;
                box-sizing: border-box;
                border-bottom: 1px solid #EEEEEE;
                position: relative;
                z-index: 999;
            }
            .active {
                position: fixed;
                left: 0;
                top: 0;
                right: 0;
                z-index: 999;
            }
            .marBot {
                padding-bottom: 180px;
            }
        }
    }
</style>
<style scoped>
    .nav /deep/ .el-tabs__nav {
        height: 91px;
    }
    .nav /deep/ .el-tabs__item {
        height: 90px;
        line-height: 90px;
        font-size: 20px;
        padding: 0 49px;
    }
    .nav /deep/ .el-tabs__item:hover {
        color: #28307C;
    }
    .nav /deep/ .el-tabs__nav-wrap::after{
        height: 0;
    }
    .nav /deep/ .el-tabs__active-bar {
        background-color: #E0B747;
    }
    .nav /deep/ .el-tabs__item.is-active {
        color: #28307C;
        font-weight: bold;
    }
    .nav /deep/ .el-tabs__header {
        margin: 0;
    }
    @media screen and (max-width: 800px) {
        .nav /deep/ .el-tabs__nav {
            height: 180px;
        }
        .nav /deep/ .el-tabs__item {
            height: 180px;
            line-height: 180px;
            font-size: 50px;
            padding: 0 49px;
        }
    }
</style>